import { AuthRepository } from '../repositories/auth.repository'
import {
    AuthSignInPayloadT,
    AuthStateT,
    GetCodeResponseT,
    GetInfoResponseT,
    SetNewPasswordPayloadT,
} from '../types/auth.types'

const authRepository = new AuthRepository()

export class AuthService {
    async signin(payload: AuthSignInPayloadT): Promise<AuthStateT> {
        const authResponse = await authRepository.signin(payload)
        return authResponse.data
    }

    async getCode(email: string): Promise<GetCodeResponseT> {
        const authResponse = await authRepository.getCode(email)
        return authResponse.data
    }

    async setNewPassword(payload: SetNewPasswordPayloadT): Promise<any> {
        const authResponse = await authRepository.setNewPassword(payload)
        return authResponse.data
    }

    async getInfo(): Promise<GetInfoResponseT> {
        const response = await authRepository.getInfo()
        return response.data
    }
}
